<script>
import { anchorLinkProps } from '@/mikan/_shared/types/vueTypes/anchorLink';

export default {
  functional: true,
  props: {
    ...anchorLinkProps,
  },
  render(h, { data, props, children, parent }) {
    const target = props.isTargetBlank ? '_blank' : '_self';
    const rel = props.isTargetBlank ? 'noopener' : '';

    const newData = {
      ...data,
      attrs: {
        ...data.attrs,
        href: props.href,
        target,
        rel,
      },
    };

    if (parent.$options._scopeId) {
      newData.attrs[parent.$options._scopeId] = '';
    }

    return h('a', newData, children);
  },
};
</script>
